import qr from 'qr-image';
import qs from 'qs';

let host = {
  picture: '/assets-view',
  video: '/assets-view',
};
if (window.settings && window.settings.host) {
  host = window.settings.host;
}
const utils = {
  host,
  isIOS: /iPhone|iPad|iPod|iOS|Mac OS/i.test(navigator.userAgent),
  isLocal: window.location.hostname === 'localhost',
  generateMixed(n) {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return Array.from({ length: n }, () => alphabet[Math.ceil(Math.random() * (alphabet.length - 1))]).join('');
  },
  generateMixedNumber(n) {
    const library = '0123456789';
    return Array.from({ length: n }, () => library[Math.ceil(Math.random() * (library.length - 1))]).join('');
  },
  getImagePath(path) {
    if (!path || path === '/static/image/default-user') {
      return '';
    }
    if (path.includes('https://')) {
      return path;
    }
    if (!path.includes(utils.host.picture)) {
      return `${utils.host.picture}${path}`;
    }
    return path;
  },
  getVideoPath(path) {
    if (!path) {
      return '';
    }
    if (path.includes('https://')) {
      return path;
    }
    if (!path.includes(utils.host.video)) {
      return `${utils.host.video}${path}`;
    }
    return path;
  },
  getDocPath(path) {
    if (!path) {
      return '';
    }
    if (path.includes('https://')) {
      return path;
    }
    if (!path.includes(utils.host.doc)) {
      return `${utils.host.doc}${path}`;
    }
    return path;
  },
  getParam() {
    const params = { ...qs.parse(window.location.search.replace('?', '')), ...qs.parse(window.location.hash.substr(window.location.hash.lastIndexOf('?') + 1)) };
    return params;
  },
  /**
   * 二维码工具类
   */
  qrUtils: {
    generateImage(text) {
      return utils.qrUtils.imgBufferToBase64(qr.imageSync(text, {
        type: 'png',
        size: 8,
        margin: 3,
      }));
    },
    imgBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      return `data:image/png;base64,${window.btoa(binary)}`;
    },
  },
  /**
   * 字符串转义解码
   * @param str
   */
  strHtmlDecode(str) {
    const targetStr = `${str}`;
    const txt = document.createElement('textarea');
    txt.innerHTML = targetStr;
    return txt.value;
  },
  /**
   * 字符串转义
   * @param str
   */
  strHtmlEncode(str) {
    const targetStr = `${str}`;
    return targetStr.trim().replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/ /g, '&nbsp;');
  },
  /**
   * 将textarea输入的数据转化成同格式html，并转义危险字符
   * @param str
   * @returns {*}
   */
  formatStr4textArea(str) {
    return this.strHtmlEncode(str).replace(/ /g, '&nbsp;').replace(/\n/g, '</br>');
  },
  /**
   * 将格式化后的textarea内容还原
   * @param str
   */
  decodeStr4textArea(str) {
    return this.strHtmlDecode(str).replace(/&nbsp;/g, ' ').replace(/<\/br>/g, '\n');
  },
  getGUID() {
    /**
     * @return {string}
     */
    function S4() {
      // eslint-disable-next-line no-bitwise
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return (`${S4() + S4()}${S4()}${S4()}${S4()}${S4()}${S4()}${S4()}`);
  },
  getFileExt(filePath) {
    if (filePath?.substring) {
      return filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
    }
    return '';
  },
  formatPhone(phone) {
    if (!phone) {
      return '';
    }
    return `${phone.substring(0, 3)}****${phone.substring(7, 11)}`;
  },
  fixedDecimal(value, precision) {
    precision = precision || 0;
    return parseFloat((parseFloat(value) || 0).toFixed(precision));
  },
  /**
   * 格式化数字
   * @param num
   * @param divisor 除数
   * @returns {*}
   */
  displayNumber(num, divisor) {
    let result;
    result = parseFloat(num);
    if (num || num === 0) {
      if (divisor) {
        result = num / divisor;
      }
      return Number(result.toFixed(2));
    }
    return '--';
  },
  getCarbonReductionByPower(power) {
    // 1度电约减排0.997kg CO2 —— 中国碳交易网
    return utils.fixedDecimal((power * 0.997) / 1000, 2);
  },
  formatUserCode(userId) {
    return `SN${`${userId}`.padStart(6, '0')}`;
  },
  /**
   * 时间格式化函数
   * @param {Date | string} date - 要格式化的日期对象或时间字符串
   * @param {string} format - 可选的格式化字符串，默认为 'YYYY-MM-DD HH:mm:ss'
   * @returns {string} 格式化后的日期字符串
   */
  formatDateTime(date, format = 'YYYY-MM-DD HH:mm:ss') {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // 月份从0开始，因此加1
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    // 根据传入的格式返回
    return format
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds);
  },

};
export default utils;
